export class Famigliare {
  birthDay: Date;
  id: string;
  rel: string;
}
